import { useMediaQuery } from "@mantine/hooks";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function useIsMobile() {
  return useMediaQuery("(max-width: 768px)");
}

export function useIsTablet() {
  return useMediaQuery("(max-width: 1280px)");
}

export function useIsSmallDevice() {
  return useMediaQuery("(max-width: 1024px)");
}
